'use strict'

import Signin from '@/pages/Auth/SignIn.vue'
import ForgotPassword from '@/pages/Auth/ForgotPassword.vue'
import ResetPassword from '@/pages/Auth/ResetPassword.vue'

import { ifNotAuthenticated } from '@/router/middleware'

export default [
  {
    path: '/',
    name: 'Home',
    component: Signin,
    meta: {layout: 'auth'},
    beforeEnter: ifNotAuthenticated
  }, {
    path: '/signin',
    name: 'signin',
    component: Signin,
    meta: {layout: 'auth'},
    beforeEnter: ifNotAuthenticated
  }, {
    path: '/activate',
    name: 'reset-password',
    component: ResetPassword,
    beforeEnter: ifNotAuthenticated,
    meta: {layout: 'auth'}
  }, {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword,
    beforeEnter: ifNotAuthenticated,
    meta: {layout: 'auth'}
  }
]



// WEBPACK FOOTER //
// ./src/router/domains/auth.js